<template>
  <div class="mt-20">
    <Aboutpage />
    <Seasons />
    <!-- <Letterform /> -->

    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>
<script>
import Aboutpage from "./components/Aboutpage.vue";
import Seasons from "./components/Seasons.vue";
import Letterform from "./components/Letterform.vue";
import DownloadApp from "../home/components/DownloadApp.vue";
import Footer from "../Footer.vue";
export default {
  components: {
    Aboutpage,
    Seasons,
    Letterform,
    DownloadApp,
    Footer,
  },
  async mounted() {
    await this.$store.dispatch("podcast/getall_category", {
      cid: this.$route.query.cid,
    });
  },
};
</script>
